import React, { Component } from 'react';
import Footer from "../components/Footer.js"
import NavBar from "../components/NavBar.js"

import '../css/main.css';

class OrderPage extends Component {
  render() {
    return (
        <div id="body">
          <NavBar />

          <div className="order_page">
            <div className="order_hero">
              <h1 className="order_hero_title">立刻享用豆日子</h1>
              <p className="order_hero_sub">選擇你喜歡的訂餐方式</p>
            </div>

            <div className="order_cards">
              {/* Official ordering — recommended */}
              <a
                href="https://order.doday.com.tw"
                target="_blank"
                rel="noopener noreferrer"
                className="order_card order_card_recommended"
              >
                <span className="order_card_badge">推薦</span>
                <span className="order_card_icon">🛒</span>
                <h2 className="order_card_name">官方線上訂餐</h2>
                <p className="order_card_desc">
                  直接透過豆日子官方訂餐系統下單，享有最完整的菜單及會員優惠
                </p>
                <span className="order_card_btn">前往訂餐</span>
              </a>

              {/* Uber Eats */}
              <a
                href="https://www.ubereats.com/tw/store/doday-%E8%B1%86%E6%97%A5%E5%AD%90%E8%B1%86%E8%8A%B1%E7%94%9C%E5%93%81%E5%BA%97-%E6%9C%A8%E6%9F%B5%E5%89%B5%E5%A7%8B%E5%BA%97/1oM8GcEMR7GI2LwFmoKNyQ"
                target="_blank"
                rel="noopener noreferrer"
                className="order_card"
              >
                <span className="order_card_icon">🚗</span>
                <h2 className="order_card_name">Uber Eats 外送</h2>
                <p className="order_card_desc">
                  透過 Uber Eats 平台訂餐，享受快速外送到府服務
                </p>
                <span className="order_card_btn">前往 Uber Eats</span>
              </a>

              {/* Foodpanda */}
              <a
                href="https://www.foodpanda.com.tw/chain/cc3jt/dou-ri-zi-dou-hua-tian-pin-dian"
                target="_blank"
                rel="noopener noreferrer"
                className="order_card"
              >
                <span className="order_card_icon">🐼</span>
                <h2 className="order_card_name">Foodpanda 外送</h2>
                <p className="order_card_desc">
                  透過 Foodpanda 平台訂餐，多種付款方式任你選擇
                </p>
                <span className="order_card_btn">前往 Foodpanda</span>
              </a>
            </div>

            {/* Walk-in info */}
            <div className="order_walkin">
              <div className="order_walkin_card">
                <h3 className="order_walkin_title">到店享用</h3>
                <div className="order_walkin_info">
                  <p>📍 台北市文山區木柵路二段149號一樓</p>
                  <p>🕐 營業時間: 每日 11:30 - 22:00</p>
                  <p>📞 訂購專線: 02-86617800</p>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </div>
    );
  }
}

export default OrderPage;
